import { IDsDoiTuongDuThiActionTypes } from "../../action-types/tct/IDsDoiTuongDuThiActions"
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase"
import { IDsDoiTuongDuThiReducer } from "../../reducer-model/tct/IDsDoiTuongDuThiReducer"

const iniState: IDsDoiTuongDuThiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dsDoiTuongDuThi: [],
    filter: {
        id_dot_thi: 0,
    },
}
export const dsDoiTuongDuThiReducer = (state: IDsDoiTuongDuThiReducer = iniState, action: IDsDoiTuongDuThiActionTypes): IDsDoiTuongDuThiReducer => {
    switch (action.type) {
        case "DOI_TUONG_DU_THI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "DOI_TUONG_DU_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dsDoiTuongDuThi: action.payload,
            }
        case "DOI_TUONG_DU_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "DOI_TUONG_DU_THI_UPDATE_DUYET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            }
        case "DOI_TUONG_DU_THI_UPDATE_DUYET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case "DOI_TUONG_DU_THI_UPDATE_DUYET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "DOI_TUONG_DU_THI_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload,
            }
        default:
            return state;
    }
}